import { z } from 'zod';

export const equipmentStandardInfoSchema = z.object({
  model: z.array(z.string()),
  year: z.array(z.string()),
  make: z.array(z.string()),
});

const requiredNullableString = z
  .string()
  .nullable()
  .refine((val): val is string => val !== null && val.trim().length > 0, { message: 'Required field' });

export const equipmentStandardSingleInfoSchema = z.object({
  model: requiredNullableString,
  year: requiredNullableString,
  make: requiredNullableString,
  modelBase: z.string().nullable(),
});

export type EquipmentStandardSingleInfoFormValues = z.input<typeof equipmentStandardSingleInfoSchema>;

export const equipmentStandardSingleInfoDefaultFormValues: EquipmentStandardSingleInfoFormValues = {
  model: null,
  year: null,
  make: null,
  modelBase: null,
};
